import { useLocation, useNavigate } from 'react-router-dom';
import type { To } from '@remix-run/router';
import type { NavigateOptions } from 'react-router/dist/lib/context';

export function useNavigatePreserveSearch() {
    const navigate = useNavigate();
    const location = useLocation();

    return (to: To, options?: NavigateOptions) => navigate(`${to}${location.search}`, options);
}
